export const viewTypes = {
  VIEW_DEFAULT: 'Default',
  VIEW_DEBUG: 'Debug',
  VIEW_DETAILED: 'Detailed'
}
